import { render, staticRenderFns } from "./ApiOutboxList.vue?vue&type=template&id=c4dbab0a&scoped=true&"
import script from "./ApiOutboxList.vue?vue&type=script&lang=js&"
export * from "./ApiOutboxList.vue?vue&type=script&lang=js&"
import style0 from "./ApiOutboxList.vue?vue&type=style&index=0&id=c4dbab0a&lang=scss&scoped=true&"
import style1 from "./ApiOutboxList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dbab0a",
  null
  
)

export default component.exports